export class GrievanceState {
    resource_uri: string;
    id: number;
    state: string;
}

export class Grievance {
    detail: number;
    time: string;
    is_advertisement: boolean;
    autopublished: boolean;
    channel: number;
    skey: string;
    state: string;
    checksum: string;
    id: number;
    tags: string;
    pub_order: number;
    location: number;
    audio_url: string;
    callerid: string;
    is_mod_flagged: boolean;
    modified_date: string;
    rating: number;
    ai: number;
    comments: number[];
    source: number;
    server: string;
    gender: string;
    qualifier: number;
    pkey: string;
    campaign_categories: number[];
    is_comment: boolean;
    format: string;
    title: string;
    transcript: string;
    reason_id: string;
    misc: string;
    age_group: number;
    occupation: string;
    category: number;
    sm_image: string;
    summary: string;
    original_item: string;
    creation_cdr: string;
    location_text: string;
    ml_properties: string;
    image_url: string;
    item_id: string;
    mnews_ai: string;
    item: any;
    dm_propeties: any;
// ai_id: number;
// detail_id: number;
// summery_id: number;
// original_item_id: number;
// creation_cdr_id: number;
// app_name: string;
}

export class Handler {
    id: number;
    location: Location;
    name: string;
    number: string;
    priority: number;
    resource_uri: string;

}

export class Location {
    ai: string;
    block: CommonData;
    desc: string;
    district: CommonData;
    id: number;
    panchayat: CommonData;
    resource_uri: string;
    state: CommonData;
    village: string;

}

export class CommonData {
    id: number;
    name: string;
    resource_uri: string;
}

export class Item {
    age_group: string;
    ai: string;
    autopublished: boolean;
    callerid: string;
    campaign_categories: any[];
    category: string;
    channel: string;
    checksum: string;
    detail: ItemDetail;
    gender: string;
    id: number;
    is_advertisement: boolean;
    is_comment: boolean;
    is_mod_flagged: boolean;
    location: string;
    location_text: string;
    misc: string;
    modified_date: string;
    nformat: string;
    occupation: string;
    pub_order: number;
    qualifier: string;
    rating: number;
    resource_uri: string;
    sm_image: string;
    source: number;
    state: string;
    tags: string;
    time: string;
    title: string;
    transcript: string;
}

export class AppInstance {
    app: number;
    conf: string;
    id: number;
    name: string;
    record_duration_limit_seconds: number;
    status: number;
}

export class ItemData {
    age_group: string;
    ai: number;
    autopublished: boolean;
    callerid: string;
    campaign_categories: CampaignCategory[];
    category: number;
    channel: number;
    comments: Comment[];
    detail: number;
    format: number;
    gender: string;
    id: number;
    is_advertisement: boolean;
    is_comment: boolean;
    is_mod_flagged: boolean;
    location: number;
    location_text: string;
    modified_date: string;
    occupation: string;
    pub_order: number;
    qualifier: number;
    rating: number;
    sm_image: string;
    source: number;
    state: string;
    summary: string;
    tags: string;
    title: string;
    transcript: string;

}

export class CampaignCategory {

}

export class Comment {

}

export class ItemDetail {
    ai: number;
    duration: string;
    id: number;
    resource_uri: string;
    url: string;
}



export class Profile {
    action: string;
    actionee: string;
    id: number;
    next_state: string;
    prev_state: string;
    resource_uri: string;
}

// tslint:disable-next-line:class-name
export class Ai_Properties {
    format: child[];
    age_group: child[];
    qualifier: child[];
    gender: child[];
    occupation: child[];
}
// tslint:disable-next-line:class-name
export class child {
    id: string;
    name: string;
}
